export const getMapQuery = (name?: string, address?: string): string =>
  address || name || '';

export const getMapUrl = (query: string): string =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
